import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT_Mapper extends BaseFormMapper<HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT> {
		return {};
	}
}

const Mappings: HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT = {
	// "0":"Print",
	type: 'Type',
	branchAddress: 'Branch Address',
	financialInstitutionName: 'Financial Institution',
	accountNumber: 'Acct #',
	finantialInstitutionNumber: 'Institution #',
	transitNumber: '5 digit',
	signatureDate4: 'Date MMDDYY_4',
	accountHolderName2: 'Name of Account Holder_2',
	signatureDate3: 'Date MMDDYY_3',
	accountHolderName: 'Name of Account Holder',
	paymentAmount: 'Payment Amount',
	paymentDate: 'Payment Date MMDDYY',
	paymentFrequency: 'Payment Frequency',
	signatureDate2: 'Date MMDDYY_2',
	signatureDate: 'Date MMDDYY',
	telephone: 'Telephone',
	address: 'Address',
	payerName: 'Payor Name',
	mortgageNumber: 'Mortgage Number If available',
};
export interface HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT {
	mortgageNumber: string;
	payerName: string;
	address: string;
	telephone: string;

	signatureDate: string;
	signatureDate2: string;

	financialInstitutionName: string;
	branchAddress: string;
	transitNumber: string;
	finantialInstitutionNumber: string;
	accountNumber: string;

	paymentFrequency: string;
	paymentDate: string;
	paymentAmount: string;

	type: string;

	accountHolderName: string;
	signatureDate3: string;

	accountHolderName2: string;
	signatureDate4: string;
}
